import { PermissionT } from "../types";

export const careersUpdates = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "careers_updates");
  return !!p;
};

export default careersUpdates;
